// compatibility for IE 9+ and Edge...
import "core-js/stable";

import {addMultipleListeners} from "@weseus/cms-core/assets/js/helpers";

import Alert from "bootstrap.native/src/components-v4/alert-native.js";
import Collapse from "bootstrap.native/src/components-v4/collapse-native.js";
import Tooltip from "bootstrap.native/src/components-v4/tooltip-native.js";
import Dropdown from "bootstrap.native/src/components-v4/dropdown-native.js";
import Modal from "bootstrap.native/src/components-v4/modal-native.js";

export default class BsInitExtension {

	constructor(naja) {
		naja.addEventListener('init', (event) => {
			this.initWsCustom(document);
		});

		naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			const snippetEl = document.getElementById(event.snippet.id);

			this.initAlert(snippetEl);
			this.initCollapse(snippetEl);
			this.initDropdown(snippetEl);
			this.initWsCustom(snippetEl);
			this.initTooltips(snippetEl);
			this.initModals(snippetEl);
		});
	}

	initAlert(block) {
		const alertElements = block.querySelectorAll('.alert > [data-dismiss="alert"]');
		alertElements.forEach((el) => {
			if (!el.Alert) {
				try {
					new Alert(el);
				} catch (e) {
					console.error("BSInitExtension", e);
				}
			}
		});
	}

	initCollapse(block) {
		const collapseElements = block.querySelectorAll('[data-toggle=collapse]');
		collapseElements.forEach((el) => {
			if (!el.Collapse) {
				try {
					new Collapse(el);
				} catch (e) {
					console.error("BSInitExtension", e);
				}
			}
		});
	}

	initTooltips(block) {
		const dropdownElements = block.querySelectorAll('[data-toggle=tooltip]');
		dropdownElements.forEach((el) => {
			if (!el.Tooltip) {
				try {
					new Tooltip(el);
				} catch (e) {
					console.error("BSInitExtension", e);
				}
			}
		});
	}

	initModals(block) {
		const modalsElements = block.querySelectorAll('[data-toggle=modal]');
		modalsElements.forEach((el) => {
			if (!el.Modal) {
				try {
					new Modal(el);
				} catch (e) {
					console.error("BSInitExtension", e);
				}
			}
		});
	}

	initDropdown(block) {
		const dropdownElements = block.querySelectorAll('[data-toggle=dropdown]');
		dropdownElements.forEach((el) => {
			if (!el.Dropdown) {
				try {
					new Dropdown(el);
				} catch (e) {
					console.error("BSInitExtension", e);
				}
			}
		});
	}

	initWsCustom(block) {

		// ------------------------------------------------------ //
		// Click / touch - checkboxes
		// ------------------------------------------------------ //

		const checkboxes = block.querySelectorAll('.fn_checkbox-collapse, .switch[data-toggle="collapse"], .switch label[data-toggle="collapse"], .switch input[data-toggle="collapse"]');
		checkboxes.forEach((el) => {
			const input = el.querySelector('input');
			const label = el.querySelector('label');
			const target = el.getAttribute('data-target') ?? input.getAttribute('data-target') ?? label.getAttribute('data-target');

			const controlEl = input.hasAttribute('data-target') ? input : (label.hasAttribute('data-target') ? label : (el.hasAttribute('data-target') ? el : null));

			const invertedCheckboxLogic = input !== null ? input.hasAttribute('data-inverted-checkbox-logic') : false;

			if (target) {
				const targetEl = document.querySelector(target);
				if (targetEl) {
					setTimeout(() => {
						if (invertedCheckboxLogic) {
							targetEl.classList.toggle('show', !input.checked);
						} else {
							targetEl.classList.toggle('show', input.checked);
						}
					}, 500);

					targetEl.addEventListener('shown.bs.collapse', function (e) {
						console.log('shown.bs.collapse', e);
						input.checked = !invertedCheckboxLogic;
					});

					targetEl.addEventListener('hidden.bs.collapse', function (e) {
						console.log('hidden.bs.collapse', e);
						input.checked = invertedCheckboxLogic;
					});
				}
			}

			addMultipleListeners(el, ['click', 'touch'], function (e) {
				if (e.detail > 1) {
					e.preventDefault();
				} else {
					if (invertedCheckboxLogic) {
						input.checked = controlEl ? controlEl.classList.contains('collapsed') : !input.checked;
					} else {
						input.checked = controlEl ? !controlEl.classList.contains('collapsed') : !input.checked;
					}
				}
			});
		});

		// ------------------------------------------------------ //
		// Tabs with radio buttons
		// ------------------------------------------------------ //

		const radio = block.querySelectorAll('.fn_checkTab');
		radio.forEach((el) => {
			const input = el.querySelector('input');
			if (input.checked) {
				el.classList.add('active');
				const selector = el.hasAttribute('href') ? el.getAttribute('href') : el.getAttribute('data-target');

				document.querySelector(selector).classList.add('active');
			}
			addMultipleListeners(el, ['click', 'touch'], function (e) {
				input.checked = true;
			});
		});

		// ------------------------------------------------------ //
		// WS Collapse
		// ------------------------------------------------------ //

		const wsCollapses = block.querySelectorAll('[data-show=collapse], [data-hide=collapse]');
		wsCollapses.forEach((el) => {
			const input = el.querySelector('input');
			const selector = el.hasAttribute('href') ? el.getAttribute('href') : el.getAttribute('data-target');
			const targets = block.querySelectorAll(selector);
			let collapses = [];

			// initialize
			if (input.checked && el.hasAttribute('data-show')) {
				el.classList.add('active');
			}

			const toggleEl = document.createElement('span');
			toggleEl.classList.add('d-none');
			document.body.appendChild(toggleEl);

			targets.forEach((target) => {
				if (input.checked && el.hasAttribute('data-show')) {
					target.classList.add('active');
				}

				collapses.push({ collapse: new Collapse(toggleEl, {target: target}), target: target})
			});

			// action
			addMultipleListeners(el, ['click', 'touch'], (e) => {
				input.checked = true;

				collapses.forEach((collapseData) => {
					let collapse = collapseData.collapse;
					const classList = collapseData.target.classList;
					if (el.hasAttribute('data-show') && !classList.contains('show')) {
						collapse.show();
					} else if (el.hasAttribute('data-hide') && classList.contains('show')) {
						collapse.hide();
					}
				});
			});
		});
	}
}